var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('CSV'),_c('Generate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }